<template>
    <q-input
        :dark="$store.state.darkMode"
        class="q-mx-sm greyBlackBgColor color__blackOnDisabled"
        outlined
        dense
        :disable="disable"
        :label="label"
        v-model="input"
        @input="onChange"
        :rules="rules ? required : []"
        :type="type"
        hide-hint
        hide-bottom-space
        :error="error"
        :maxlength="maxlength"
        no-error-icon
        :mask="mask"
        ref="inputRef"
    />
</template>

<script>
export default {
    props: ['disable', 'model', 'label', 'value', 'rules', 'type', 'error', 'maxlength', 'mask', 'hint'],
    mounted() {
        this.input = this.value;
    },
    data() {
        return {
            input: this.value,
        };
    },

    methods: {
        onChange() {
            this.$emit('change', this.model, this.input);
        },

        setValue(val) {
            this.input = val;
        },
        handleFocus() {
            this.$refs.inputRef.focus();
        },
        required(value) {
            console.log('value: ', !!value, value);
            return !!value || 'This field is required';
        },
    },
    watch: {
        value: function () {
            this.input = this.value;
        },
    },
};
</script>

<style lang="scss" scoped></style>
